import { render, staticRenderFns } from "./weekly-agenda.vue?vue&type=template&id=210b8126&"
import script from "./weekly-agenda.vue?vue&type=script&lang=js&"
export * from "./weekly-agenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports